/**
 * Created by zhaoming@ronglian.com on 2019/12/3.
 */

/**
 * 生成uuid-36
 * @returns {string}
 */
export function uuid36() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
    let r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
  });
}

/**
 * 生成uuid-32
 * @returns {string}
 */
export function uuid32() {
  return uuid36().replace(/-/g, '');
}